import axios from 'axios';
import { constants } from '../../constants';

export function createChatroom(
  name: string,
  activityTemplateId: string,
  activateNow: boolean,
  chatroomId?: string
) {
  const token = localStorage.getItem('token');
  let url = `${constants.endpoint}/chatrooms`;

  if (chatroomId) {
    url = `${url}?createFrom=${chatroomId}`;
  }

  return axios.post<{ inviteUrl: string }>(
    url,
    {
      name,
      activityTemplateId,
      activateNow,
    },
    {
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  );
}
